import React from "react";
import DataTable from "react-data-table-component";
import { useSearchParams } from "react-router-dom";
import Loader from "./Loader";

const CustomTable = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  //  const handlePageChange = (page) => {
  //    const newSearchParams = new URLSearchParams(searchParams); // Create a new URLSearchParams object
  //    newSearchParams.set("page", page);
  //    setSearchParams(newSearchParams); // Update searchParams with the new object
  //  };

  //  const handleRowsPerPageChange = (currentRowsPerPage) => {
  //    const newSearchParams = new URLSearchParams(searchParams);
  //    newSearchParams.set("per_page", currentRowsPerPage);
  //    setSearchParams(newSearchParams);
  //  };
  return (
    <DataTable
      pagination
      paginationServer
      paginationTotalRows={props.paginationTotalRows}
      paginationPerPage={parseInt(searchParams.get("per_page")) || 10}
      paginationDefaultPage={parseInt(searchParams.get("page")) || 1}
      onChangePage={(page) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("page", page);
        setSearchParams(newParams);
      }}
      onChangeRowsPerPage={(newPerPage, currentPage) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("per_page", newPerPage);
        newParams.set("page", 1); // reset to first page when perPage changes
        setSearchParams(newParams);
      }}
      paginationComponentOptions={{
        rowsPerPageText: "Items per page",
        rangeSeparatorText: "of",
      }}
      progressComponent={<Loader spin />}
      {...props}
      customStyles={{
        table: {
          style: {
            border: "1px solid #EAEBF0",
            borderRadius: 8,
            minWidth: '1400px',
          }
        },
        rows: {
          style: {
            paddingBlock: 20
          }
        },
        headRow: {
          style: {
            fontWeight: 500,
            backgroundColor: "#F6F6F6"
          }
        },
      }}
    />
  );
};

export default CustomTable;
